module.exports = __webpack_public_path__ + "img/1257074949.2ce7d763.jpg";